import React from "react";
import { PawPrint, Key, Backpack, Star, Heart, Cat, Dog, Bird, Butterfly, Car, Rocket, IceCream, UploadSimple } from "@phosphor-icons/react";
import { API } from "@/lib/api";

const PRESET_IDS = ["dino", "bunny", "teddy", "robot", "monster"];

export const MOTIFS = [
  { id: "dino", label: "Dino", img: true },
  { id: "bunny", label: "Hase", img: true },
  { id: "teddy", label: "Teddy", img: true },
  { id: "robot", label: "Roboter", img: true },
  { id: "monster", label: "Monster", img: true },
  { id: "paw", label: "Pfote", Icon: PawPrint },
  { id: "dog", label: "Hund", Icon: Dog },
  { id: "cat", label: "Katze", Icon: Cat },
  { id: "bird", label: "Vogel", Icon: Bird },
  { id: "butterfly", label: "Schmetterling", Icon: Butterfly },
  { id: "car", label: "Auto", Icon: Car },
  { id: "rocket", label: "Rakete", Icon: Rocket },
  { id: "icecream", label: "Eis", Icon: IceCream },
  { id: "heart", label: "Herz", Icon: Heart },
  { id: "star", label: "Stern", Icon: Star },
  { id: "key", label: "Schlüssel", Icon: Key },
  { id: "backpack", label: "Rucksack", Icon: Backpack },
];

export function motifById(id) {
  return MOTIFS.find((m) => m.id === id && m.Icon) || MOTIFS.find((m) => m.Icon);
}

export function AvatarDisplay({ type, value, size = 72, className = "" }) {
  const token = localStorage.getItem("sb_token");
  if (type === "upload" && value) {
    const src = `${API}/files/${value}${token ? `?auth=${token}` : ""}`;
    return (
      <div className={`rounded-2xl overflow-hidden border-2 border-gray-800 bg-white ${className}`} style={{ width: size, height: size }}>
        <img src={src} alt="avatar" className="w-full h-full object-cover" />
      </div>
    );
  }
  if (type === "preset" && PRESET_IDS.includes(value)) {
    return (
      <div className={`rounded-2xl border-2 border-gray-800 bg-white flex items-center justify-center overflow-hidden ${className}`} style={{ width: size, height: size }}>
        <img src={`/avatars/${value}.png`} alt="avatar" className="w-full h-full object-contain p-1" />
      </div>
    );
  }
  if (type === "emoji" && value) {
    return (
      <div className={`rounded-2xl border-2 border-gray-800 bg-white flex items-center justify-center ${className}`} style={{ width: size, height: size }}>
        <span style={{ fontSize: size * 0.55, lineHeight: 1 }}>{value}</span>
      </div>
    );
  }
  if (!value || value === "paw" || value === "logo") {
    return (
      <div className={`rounded-2xl border-2 border-gray-800 flex items-center justify-center overflow-hidden ${className}`}
        style={{ width: size, height: size, background: "#fff" }}>
        <img src="/logo.png" alt="SafeBuddy" className="w-full h-full object-contain" style={{ padding: size * 0.16 }} />
      </div>
    );
  }
  const { Icon } = motifById(value);
  return (
    <div className={`rounded-2xl border-2 border-gray-800 flex items-center justify-center ${className}`}
      style={{ width: size, height: size, background: "var(--app-primary)" }}>
      <Icon size={size * 0.55} weight="duotone" color="#fff" />
    </div>
  );
}

export function MotifPicker({ selectedType, selectedValue, onSelect, onUpload, testidPrefix = "motif", uploadOnly = false }) {
  const [emoji, setEmoji] = React.useState("");
  const presets = MOTIFS.filter((m) => m.img);
  const customActive = selectedType === "emoji" || selectedType === "upload";
  return (
    <div className="flex flex-wrap gap-2 items-center">
      {!uploadOnly && presets.map((m) => {
        const active = selectedType === "preset" && selectedValue === m.id;
        return (
          <button key={m.id} type="button" data-testid={`${testidPrefix}-${m.id}`} title={m.label}
            onClick={() => onSelect("preset", m.id)}
            className="p-2 rounded-xl border-2 active:scale-90 transition-all flex items-center justify-center"
            style={{ width: 52, height: 52, borderColor: active ? "var(--app-primary)" : "#1F2937", background: "#fff", boxShadow: active ? "0 0 0 3px var(--app-primary)" : "none" }}>
            <img src={`/avatars/${m.id}.png`} alt={m.label} className="w-full h-full object-contain" />
          </button>
        );
      })}
      {(uploadOnly ? selectedType === "upload" : customActive) && (
        <div data-testid={`${testidPrefix}-custom-preview`} className="rounded-xl border-2 flex items-center justify-center overflow-hidden"
          style={{ width: 52, height: 52, borderColor: "var(--app-primary)", boxShadow: "0 0 0 3px var(--app-primary)", background: "#fff" }}>
          {!uploadOnly && selectedType === "emoji" ? <span style={{ fontSize: 26 }}>{selectedValue}</span> : <AvatarDisplay type="upload" value={selectedValue} size={48} />}
        </div>
      )}
      {!uploadOnly && (
        <input data-testid={`${testidPrefix}-emoji`} value={emoji}
          onChange={(e) => { const v = [...(e.target.value || "")].slice(-1)[0] || ""; setEmoji(v); if (v) onSelect("emoji", v); }}
          placeholder="😀" maxLength={2}
          className="rounded-xl border-2 border-gray-800 bg-white text-center outline-none" style={{ width: 52, height: 52, fontSize: 24 }} title="Eigenes Emoji" />
      )}
      {onUpload && (
        <label data-testid={`${testidPrefix}-upload`} className="rounded-xl border-2 border-dashed border-gray-800 bg-white flex items-center justify-center cursor-pointer active:scale-90" style={{ width: 52, height: 52 }} title="Bild hochladen">
          <UploadSimple size={22} weight="bold" className="text-gray-700" />
          <input type="file" accept="image/*" hidden onChange={onUpload} />
        </label>
      )}
    </div>
  );
}
